import accountArrow from './account_arrow.json.js';
import ani51 from './ani_5-1.json.js';
import aniD1 from './ani_D-1.json.js';
import aniD2 from './ani_D-2.json.js';
import aniLtv110 from './ani_ltv_1-10.json.js';
import Balance_Consolidation from './Balance_Consolidation.json.js';
import Incoming from './Incoming.json.js';
import OnBoarding1 from './onboarding1.json.js';
import OnBoarding2 from './onboarding2.json.js';
import OnBoarding3 from './onboarding3.json.js';
import Outgoing from './Outgoing.json.js';
import scbRetail from './scb_retail.json.js';
import trustmarkSpinner from './trustmark_spinner.json.js';

const LOTTIE_ANIMATIONS = {
  aniD1,
  aniD2,
  ani51,
  aniLtv110,
  accountArrow,
  trustmarkSpinner,
  scbRetail,
  Balance_Consolidation,
  Incoming,
  Outgoing,
  OnBoarding1,
  OnBoarding2,
  OnBoarding3
};

export { LOTTIE_ANIMATIONS };
